import { render, staticRenderFns } from "./StepAppearance.vue?vue&type=template&id=26b2d9f4&scoped=true&"
import script from "./StepAppearance.vue?vue&type=script&lang=ts&"
export * from "./StepAppearance.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b2d9f4",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VForm,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26b2d9f4')) {
      api.createRecord('26b2d9f4', component.options)
    } else {
      api.reload('26b2d9f4', component.options)
    }
    module.hot.accept("./StepAppearance.vue?vue&type=template&id=26b2d9f4&scoped=true&", function () {
      api.rerender('26b2d9f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/wizard/StepAppearance.vue"
export default component.exports